// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".awsui_root_37gf8_1b8da_9:not(#\\9){display:flex;flex-direction:row;flex-wrap:wrap;gap:var(--space-xs-xf5ch3, 8px)}.awsui_root_37gf8_1b8da_9>:not(#\\9):empty{display:none}\n", ""]);
// Exports
module.exports = exports;
